import { IDeskContext } from 'client/components/schema/desk/context/DeskContext';
import { DeskWidgetsLogic } from 'client/components/schema/desk/logic/DeskWidgetsLogic';
import {
  createToolkitAction,
  ToolkitAction
} from 'client/components/toolkit/actions/ToolkitAction';
import { IToolkitActionContext } from 'client/components/toolkit/actions/ToolkitActionContext';
import {
  getToolkitObjectOfType,
  ToolkitObject
} from 'client/components/toolkit/objects/ToolkitObject';
import { WidgetToolkitObject } from 'client/components/toolkit/objects/WidgetToolkitObject';
import { DamToolkitObject } from 'client/components/widget-repository/objects/dams/DamToolkitObject';
import { set } from 'client/core/data/set';
import { FvIconDamEye } from 'client/ui/icon/FvIconsDam';
import React from 'react';
import { WidgetDamGeoregistryViewerType } from '../WidgetDamGeoregistryViewer.type';
import { WidgetDamGeoregistryViewerProfile } from '../WidgetDamGeoregistryViewerProfile';

export const WidgetActionViewDamGeoregistry = createToolkitAction({
  name: 'Geoanagrafica Diga',
  code: 'view-dam-georegistry',
  icon: <FvIconDamEye />,
  arguments: [
    {
      type: [DamToolkitObject],
      name: 'Diga di cui mostrare la Geoanagrafica'
    },
    {
      type: [WidgetToolkitObject],
      allows: (object: ToolkitObject) =>
        WidgetToolkitObject.matches(object, WidgetDamGeoregistryViewerType),
      name: 'Widget Geoanagrafica Diga'
    }
  ],
  async execute(
    ctx: IToolkitActionContext,
    object: ToolkitObject,
    targetObject: ToolkitObject | null
  ) {
    const dam = DamToolkitObject.get(object)!;
    const target = WidgetToolkitObject.get(targetObject);

    const data: WidgetDamGeoregistryViewerProfile = {
      damId: dam.id as string,
      damDescription: `${dam.data.id} - ${dam.data.name}`
    };

    if (target) {
      const widget = ctx.deskContext.widgets.find(w => w.id === target.id)!;
      await ctx.deskContext.updateWidget(set(widget, 'profile.data', data));
      return;
    }

    await ctx.deskContext.cloneWidget(
      {
        type: 'floating',
        expanded: true,
        order: DeskWidgetsLogic.getFloatingNextOrder(
          ctx.deskContext.floatingWidgets
        )
      },
      WidgetDamGeoregistryViewerType,
      ctx.sourceWidget!,
      { data, quickClose: true }
    );
  }
});
